import React from 'react';

import {Icon, Approve} from '@optimaxdev/icons';

import {Price} from 'components/price/price';
import {ShippingMethodType} from 'types/shippingMethodsType';

import s from './shippingSingleMethod.scss';

export type PropsType = {
    shippingMethod: ShippingMethodType;
};

/**
 * Shipping Single Method for shipping methods list
 *
 * @constructor
 */
export const ShippingSingleMethod: React.FC<PropsType> = ({
    shippingMethod: {description, price, title},
}) => {
    const label = Number(price) === 0 ? 'Free' : title;
    const deliveryPrice = Number(price) === 0 && (
        <>
            {' '}
            (<Price>{price}</Price>)
        </>
    );

    return (
        <div className={s.singleMethod}>
            <div className={s.icon}>
                <Icon icon={Approve} />
            </div>
            <p className={s.green}>{label} Shipping</p>
            <p className={s.grey}>
                {description}
                {deliveryPrice}
            </p>
        </div>
    );
};
